"use client";

import { useTRPC } from "@/lib/trpc/client";
import type { EntityPermissions } from "@/db/auth/permissions";

/**
 * Web projection of server-resolved effective permissions.
 * Tenant overrides, custom roles, and stage markers are resolved by the same
 * read operation used by projected/headless consumers.
 */
export function useEffectiveEntityPermissions(
  entity: "imoveis" | "negociacoes" | "tarefas"
): EntityPermissions | undefined {
  return useEffectiveEntityPermissionsState(entity).permissions;
}

export function useEffectiveEntityPermissionsState(
  entity: "imoveis" | "negociacoes" | "tarefas"
): {
  permissions: EntityPermissions | undefined;
  isResolved: boolean;
  isError: boolean;
  refetch: () => Promise<unknown>;
} {
  const trpc = useTRPC();
  const query = trpc.auth.affordances.entity.useQuery({ entity });
  const hasPayload = query.data != null;
  return {
    permissions: query.data?.effectivePermissions ?? undefined,
    isResolved: hasPayload,
    isError: query.isError && !hasPayload,
    refetch: query.refetch,
  };
}
